import { Box, Text, Image } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../../constant";

// 根據維護日索引取得對應的星期字串
const getWeekDayString = (dayIndex) => {
  const weekDays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  return weekDays[dayIndex] || "";
};

/**
 * @description: 維護公告內容
 * @return {JSX.Element}
 */
const MaintenanceContent = () => {
  const { t } = useTranslation();

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { allGamePlatform = [] } = isHandleAllGame;

  /**
   * 篩選出有維護時間的遊戲平台
   * 條件
   * 1. maintenanceStartTime 有值且不等於 "00:00:00"
   * 2. maintenanceEndTime 有值且不等於 "00:00:00"
   * 3. maintenance_day_of_week 有值
   */
  const maintenanceList = allGamePlatform.filter((item) => {
    const isOpenStart =
      item.maintenanceStartTime && item.maintenanceStartTime !== "00:00:00";
    const isOpenEnd =
      item.maintenanceEndTime && item.maintenanceEndTime !== "00:00:00";
    const weekDay = item.maintenance_day_of_week;
    return isOpenStart || isOpenEnd || weekDay;
  });

  if (maintenanceList.length === 0) {
    return <Text textAlign={"center"}>{t("announcement.noMaintenance")}</Text>;
  }

  return (
    <>
      <Box sx={{ marginBottom: "16px" }}>
        <Text>{t("announcement.maintenanceReminder")}</Text>
        <Text sx={{ fontWeight: "bold", marginBottom: "16px" }}>
          {t("announcement.maintenanceSchedule")}
        </Text>
        {maintenanceList.map((maintenance) => {
          return (
            <Box
              key={maintenance.platform}
              width={"100%"}
              bgColor={"#F4F0F6"}
              borderRadius={"16px"}
              display={"flex"}
              alignItems={"center"}
              gap={"16px"}
              boxShadow={"0px 4px 4px rgba(0, 0, 0 ,0.25)"}
              marginY={"15px"}
              padding={"16px"}
              color={"#625275"}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                w="60px"
                h="60px"
                mt={1}
                mb={1}
                padding={1}
                borderRadius={"8px"}
                bgColor={"lightgray"}
              >
                <Image
                  src={`${COMMON_WEB_PATH}/ds88platformIcon/${maintenance.platformEnum}.png`}
                />
              </Box>
              <Box
                sx={{
                  width: "3px",
                  alignSelf: "stretch",
                  backgroundColor: "#C9C4CC",
                  opacity: 0.5,
                }}
              />

              <Box>
                <Box height={"100%"} fontWeight={"bold"}>
                  {maintenance.platform}
                </Box>
                <Text>
                  {`${t("announcement." + getWeekDayString(maintenance.maintenance_day_of_week))} ${t("announcement.routineMaintenance")}`}
                </Text>
                <Text fontWeight={"bold"}>
                  {`${maintenance.maintenanceStartTime} ~ ${maintenance.maintenanceEndTime}`}
                </Text>
              </Box>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default MaintenanceContent;
